import { useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import Seo from "../components/Seo";
import "../components/booth/tokens.css";
import BoothMark from "../components/booth/BoothMark";
import ContactForm from "../components/booth/ContactForm";
import Toast from "../components/booth/Toast";
import Footer from "../components/booth/Footer";
import "./ContactUs.css";

function ContactUs() {
  const navigate = useNavigate();
  const [toastOpen, setToastOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastSeverity, setToastSeverity] = useState("success");

  const notify = useCallback((message, severity = "success") => {
    setToastMessage(message);
    setToastSeverity(severity);
    setToastOpen(true);
  }, []);

  return (
    <div className="booth booth-contact-page">
      <Seo
        title="Contact us — The Booth"
        description="Questions, feedback, or bug reports? Get in touch with The Booth team."
        path="/contactus"
      />
      <header className="booth-shell booth-contact-masthead">
        <a
          href="/"
          className="booth-contact-mark-link"
          onClick={(e) => {
            e.preventDefault();
            navigate("/");
          }}
        >
          <BoothMark />
        </a>
      </header>
      <main className="booth-shell booth-contact-main">
        <ContactForm
          onSuccess={() => notify("Message sent, thanks for reaching out!", "success")}
          onFailure={() => notify("Oops! Something went wrong, please try again.", "error")}
        />
      </main>
      <Footer />
      <Toast
        open={toastOpen}
        message={toastMessage}
        severity={toastSeverity}
        onClose={() => setToastOpen(false)}
      />
    </div>
  );
}

export default ContactUs;
